<template>
  <div class="row categoryitem-wrap">
    <div class="col-md-12 categoryitem" v-on:click="openCategory(category)">
      <div class="categorydetails">
        <div class="categorytitle"><h4><a href="javascript:;"><span class="fa fa-folder fa-fw" v-if="category"></span><span class="fa fa-folder-open fa-fw" v-else></span>{{ title }}</a></h4></div>
        <div class="categorydescription" v-if="false">{{ $filters.htmlentities($filters.striptags(category.description)) }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['category', 'title'],
  methods: {
    openCategory (category) {
      if (category) {
        this.$emit('openCategory', category.id, category.name)
      } else {
        this.closeCategory()
      }
    },
    closeCategory() {
      this.$emit('closeCategory')
    }
  }
}

</script>
